import React from 'react';
import { Network, BarChart3, FileText, SlidersHorizontal } from 'lucide-react';

export type MainTabType = 'map' | 'metrics' | 'check' | 'settings';

export interface NavigationTabsProps {
  activeTab: MainTabType;
  onChange: (tab: MainTabType) => void;
  className?: string;
}

interface TabDef {
  id: MainTabType;
  label: string;
  icon: React.ReactNode;
}

const TABS: TabDef[] = [
  { id: 'map', label: 'Мапа', icon: <Network className="w-5 h-5" /> },
  { id: 'metrics', label: 'Показники', icon: <BarChart3 className="w-5 h-5" /> },
  { id: 'check', label: 'Чек', icon: <FileText className="w-5 h-5" /> },
  { id: 'settings', label: 'Параметри', icon: <SlidersHorizontal className="w-5 h-5" /> },
];

export const NavigationTabs: React.FC<NavigationTabsProps> = ({
  activeTab,
  onChange,
  className = '',
}) => {
  return (
    <nav
      role="navigation"
      aria-label="Головна мобільна навігація"
      className={`
        fixed bottom-0 left-0 right-0 z-40 bg-[#0A0F1D]/95 backdrop-blur-2xl
        border-t border-white/10 px-2 py-1.5 md:hidden shadow-[0_-10px_30px_rgba(0,0,0,0.8)]
        pb-[max(0.5rem,env(safe-area-inset-bottom))]
        ${className}
      `}
    >
      <div className="grid grid-cols-4 gap-1">
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              data-tour-tab={tab.id}
              type="button"
              onClick={() => onChange(tab.id)}
              className={`
                flex flex-col items-center justify-center py-1.5 px-1 rounded-xl
                transition-all duration-200 min-h-[48px] cursor-pointer select-none
                ${
                  isActive
                    ? 'text-accent-neon bg-emerald-500/10 font-bold shadow-[0_0_12px_rgba(0,229,153,0.15)]'
                    : 'text-text-muted hover:text-text-primary hover:bg-white/5 font-medium'
                }
              `}
            >
              <div className="relative">
                {tab.icon}
                {isActive && (
                  <span className="absolute -top-1 -right-1 w-1.5 h-1.5 rounded-full bg-accent-neon shadow-[0_0_8px_#00E599]" />
                )}
              </div>
              <span className="text-[11px] mt-1 tracking-tight leading-none">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
